import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface EscalationConfirmationData {
    title?: string;
    message?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    standardAchievedButtonText?: string;
    showStandardAchievedButton?: boolean;
}

@Component({
    selector: 'app-escalation-confirmation-dialog',
    templateUrl: './escalation-confirmation-dialog.component.html',
    styleUrls: ['./escalation-confirmation-dialog.component.scss'],
    standalone: false
})
export class EscalationConfirmationDialogComponent {
    title: string;
    message: string;
    confirmButtonText: string;
    cancelButtonText: string;
    standardAchievedButtonText: string;
    showStandardAchievedButton: boolean;

    constructor(
        public dialogRef: MatDialogRef<EscalationConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EscalationConfirmationData
    ) {
        this.title = data?.title || 'Confirm Escalation – Out of my scope';
        this.message = data?.message || '⚠️ You may be about to decline care to this patient.\n\nBefore proceeding, please ensure you have:\n• Conducted a real-time consultation with the patient\n• Completed a basic safety assessment\n• Provided appropriate advice\n\n⚠️ Declining care without proper consultation may fall below the acceptable standard of care under AHPRA guidelines.\n\nDo you wish to proceed with the system recording your decision?';
        this.confirmButtonText = data?.confirmButtonText || 'Decline Care';
        this.cancelButtonText = data?.cancelButtonText || 'Cancel';
        this.standardAchievedButtonText = data?.standardAchievedButtonText || 'Standard Achieved';
        this.showStandardAchievedButton = data?.showStandardAchievedButton !== false; // Default to true
    }

    onConfirm(): void {
        this.dialogRef.close('decline');
    }

    onCancel(): void {
        this.dialogRef.close('cancel');
    }

    onStandardAchieved(): void {
        // This performs the same action as decline in the background (escalation)
        // but provides a more subtle option for clinicians
        this.dialogRef.close('standard-achieved');
    }
}